export default __webpack_public_path__ + "static/media/instagram_black_icon.2936d99e.png";